/**
 *  <Desription of Service here>
 *
 * @export
 * @class ProgressManager
 */
export class ProgressManager {
  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = [
    "$log",
    "LocalStorageManager",
    "$rootScope"
  ];

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(
    public $log: any,
    public LocalStorageManager: any,
    public $rootScope: any,
    public ScreenManager: any
  ) {
    this.$log = $log.getInstance("ProgressManager", false);
    this.$log.debug("constructor");
  }

  public valueExists(val): boolean {
    // this.$log.debug('valueExists', val)
    return !angular.isUndefined(val) && val !== null;
  }

  public set(key: string, value: any): any {
    // this.$log.debug('set', key, value, this.LocalStorageManager.isSupported())
    if (this.LocalStorageManager.isSupported()) {
      return this.LocalStorageManager.set(key, value);
    }
  }

  public get(key: string): any {
    // this.$log.debug('get', key, this.LocalStorageManager.isSupported())
    if (this.LocalStorageManager.isSupported()) {
      return this.LocalStorageManager.get(key);
    }
  }

  /*
  0.  Store Screen Index
  1.  Store Gender
  2.  Store Pose
  3.  Store SVG in current state
  4.  Store Cover Background Image
  5.  Store Cover Stickers & Hero Information
  */

  public applySavedProgress(): void {
    this.$log.debug("applySavedProgress");
    let screenIndex = this.getScreenIndex();
    if (this.valueExists(screenIndex)) {
      let gender = this.getGender();
      if (this.valueExists(gender)) {
        this.$log.debug(gender);
        this.$rootScope.$broadcast("progress:gender", { gender: gender });
      }

      let pose = this.getPose();
      if (this.valueExists(pose)) {
        this.$log.debug(pose);
        this.$rootScope.$broadcast("progress:pose", { pose: pose });
      }

      let stickers = this.getStickers();
      if (this.valueExists(stickers)) {
        this.$log.debug(stickers);
        this.$rootScope.$broadcast("progress:stickers", { stickers: stickers });
      }

      let coverBG = this.getCoverBG();
      if (this.valueExists(coverBG)) {
        this.$log.debug(coverBG);
        this.$rootScope.$broadcast("progress:coverBG", { coverBG: coverBG });
      }
    }
  }

  public jumpToSavedScreen() {
    this.$log.debug("jumpToSavedScreen");
    let screenIndex = this.getScreenIndex();
    if (this.valueExists(screenIndex)) {
      this.$rootScope.$broadcast("progress:screen", {
        screenIndex: screenIndex
      });
    }
  }

  public setScreenIndex(index: number): void {
    // this.$log.debug('setScreenIndex', index)
    this.set("PROGRESS_SCREEN_INDEX_GOTG", index);
  }

  public getScreenIndex(): number {
    // this.$log.debug('getScreenIndex', this.get('PROGRESS_SCREEN_INDEX_GOTG'))
    return this.get("PROGRESS_SCREEN_INDEX_GOTG");
  }

  public setGender(gender: any): void {
    this.set('PROGRESS_GENDER_GOTG', gender);
  }

  public getGender(): any {
    return this.get('PROGRESS_GENDER_GOTG');
  }

  public setPose(pose: any): void {
    this.set('PROGRESS_POSE_GOTG', pose);
  }

  public getPose(): any {
    return this.get('PROGRESS_POSE_GOTG');
  }

  public setHero(hero: any): void {
    this.set('PROGRESS_HERO_GOTG', hero);
  }

  public getHero(): any {
    return this.get('PROGRESS_HERO_GOTG');
  }

  public setCoverBG(bg: any): void {
    this.set('PROGRESS_COVER_BG_GOTG', bg);
  }

  public getCoverBG(): any {
    return this.get('PROGRESS_COVER_BG_GOTG');
  }

  public setSticker(sticker: any): void {
    // this.$log.debug('setSticker', sticker)
    // grab existing sticker data
    let stickers = this.getStickers();

    // if there is no sticker list yet make one and set it
    if (!this.valueExists(stickers)) {
      this.set('PROGRESS_STICKERS_GOTG', []);
      stickers = this.get('PROGRESS_STICKERS_GOTG');
    }

    // heros should only ever be one
    if (sticker.isHero) {
      let heroCount = stickers.filter((sticker: any) => {
        return sticker.isHero;
      });

      // hero sticker is always index 0
      if (heroCount.length) {
        stickers[0] = sticker;
      } else {
        stickers.push(sticker);
      }
    } else {
      // if its a normal sticker we can have multiples but make sure we don't have duplicates of the same instance of sticker

      let match = stickers.findIndex((element, index, array) => {
        if (element.name === sticker.name) {
          return true;
        }
      });

      if (match > 0) {
        // existing sticker, replace it or delete it
        if (sticker.shouldDelete) {
          stickers.splice(match, 1);
        } else {
          stickers[match] = sticker;
        }
      } else {
        // ifs a new sticker save it or delete it
        if (!sticker.shouldDelete) {
          stickers.push(sticker);
        }
        // } else {
        //   stickers.splice(match, 1);
        // }
      }
    }

    // update the stickers list in ls
    this.set('PROGRESS_STICKERS_GOTG', stickers);
  }

  public getStickers(): any {
    return this.get('PROGRESS_STICKERS_GOTG');
  }

  public reset() {
    this.set('PROGRESS_STICKERS_GOTG', []);
    localStorage.removeItem('heromaker.PROGRESS_HERO_GOTG');
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/services/progress-manager/progress-manager.ts
 **/